import { Button, Icon, Modal } from '@octano/global-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router';
import { Col, Row } from 'reactstrap';
import { clean, validate } from 'rut.js';

import {
  LoginTuitionProcessError,
  loginTutionProcess,
} from '../../../api/requests/tuitionProcess';
import IdentificationTypesLoader from '../../../components/IdentificationTypesLoader';
import LoginForm from '../../../components/loginForm/LoginForm';
import { LoginInputs } from '../../../components/loginForm/types';
import { useUserState } from '../../../hooks/useUserState';
import { LoginTuitionProcessBody } from '../../../types/loginTypes';
import { setJWT } from '../../../utils/auth';
import { formatDate } from '../../../utils/dates';

const formatData = (
  values: LoginInputs,
  admissionId?: number,
): LoginTuitionProcessBody => {
  return {
    identificationTypeId: values?.identificationType?.value?.toString() || '',
    identificationValue:
      values?.identificationType?.value?.toString() === 'CL_RUT'
        ? clean(values.identificationValue)
        : values.identificationValue,
    identificationCountryId:
      values?.identificationCountry?.value?.toString() || null,
    birthday: formatDate(values.birthday, 'YYYY-MM-DD'),
    processType: 'sin-sua',
    admissionId,
  };
};

const LoginFormNoSuaProcess = () => {
  const prefix = 'loginTuitionProcess';
  const { t } = useTranslation();
  const { setIsLogged } = useUserState();
  const history = useHistory();
  const location = useLocation<{ admissionId?: number }>();
  const admissionId = location.state?.admissionId;

  const [errorLogin, setErrorLogin] = useState('');
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const [
    failedLoginValues,
    setFailedLoginValues,
  ] = useState<LoginInputs | null>(null);

  const resolveError = (resultError: LoginTuitionProcessError) => {
    if (
      ['notFound', 'INVALID_CREDENTIALS', 'NOT_FOUND_POSTULANT'].includes(
        resultError.code,
      )
    ) {
      setIsModalOpen(true);
    } else {
      setErrorLogin(
        ['invalidFields'].includes(resultError.code)
          ? resultError.code
          : 'unknownError',
      );
    }
  };

  const onLogin = async (values: LoginInputs) => {
    const payload = formatData(values, admissionId);
    if (
      payload?.identificationTypeId === 'CL_RUT' &&
      !validate(payload.identificationValue)
    ) {
      setErrorLogin('invalidRut');
      return;
    }
    const { data, error } = await loginTutionProcess(payload);
    if (data) {
      setJWT(data.accessToken);
      setIsLogged(true);
    }
    if (error) {
      setFailedLoginValues(values);
      console.log('error', error);
      resolveError(error);
    }
  };

  const onPressRegistrationBtn = () => {
    setIsModalOpen(false);
    history.push('/auth/registration?from=login', failedLoginValues);
  };

  return (
    <>
      <IdentificationTypesLoader>
        {({ data: identificationTypes }) => {
          return (
            <LoginForm
              identificationTypes={identificationTypes}
              onLogin={onLogin}
              errorLogin={errorLogin}
              toggleError={() => setErrorLogin('')}
            />
          );
        }}
      </IdentificationTypesLoader>

      <Modal
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(false)}
        closeOnBackdrop={false}
      >
        <Row className="text-center">
          <Col xs={12} className="pb-2">
            <Icon name="information" size="52px" color="secondary" />
          </Col>
          <Col xs={12} className="pt-4 text-dark fw-400">
            <p className="fs-22">
              {t(`${prefix}.unregisteredUserModal.title`)}
            </p>
          </Col>
          <Col xs={12}>
            <p className="fs-18 fw-300">
              {t(`${prefix}.unregisteredUserModal.body`)}
            </p>
          </Col>
          <Col xs={12} className="px-5 pt-4">
            <Button
              text={t(`${prefix}.unregisteredUserModal.btnRegistration`)}
              onClick={onPressRegistrationBtn}
              fullwidth
            />
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default LoginFormNoSuaProcess;
